import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StorageLocationsSetupState } from './storage-locations-setup.model';

export const selectStorageLocationSetupState =
  createFeatureSelector<StorageLocationsSetupState>('storageLocationsSetup');
export const selectStorageLocationSetupError = createSelector(selectStorageLocationSetupState, (state) => state.error);
export const selectStorageLocationSetupIsLoading = createSelector(
  selectStorageLocationSetupState,
  (state) => state.isLoading,
);
